import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper";
import { Community1, Community2, Nft4, Nft5, Nft6 } from "../../constant/Index";
import Faqs from "../../components/Faqs";
import { useSiteContentQuery } from "../../store/services/SitesettingService";
import {
	useCommunityContentQuery,
	useCommunityFaqsContentQuery,
} from "../../store/services/CommunityService";
import { useImageContentQuery } from "../../store/services/ImageService";

const Community = () => {
	const { data, isLoading } = useSiteContentQuery();
	const { data: communityfaqs, isLoading: communityfaqsLoading } =
		useCommunityFaqsContentQuery();
	const { data: community, isLoading: communityLoading } =
		useCommunityContentQuery();
	const { data: nftImage, isLoading: nftLoading } = useImageContentQuery();
	let NftImages = nftImage?.response?.data;
	let communityData = data?.response?.data[0];
	let communityFaqs = communityfaqs?.response?.data;
	let CommunityTypes = community?.response?.data;
	console.log(communityFaqs);

	return (
		<>
			{/* Header Start Here */}
			<Header />
			{/* Header End Here */}

			{/* <!-- About Sec Start Here --> */}
			<section className="about_page">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-6">
							<div className="content-wrapper">
								<div className="glowing glowing-one">
									<span></span>
								</div>
								<div className="heading-wrapper">
									<h4>COMMUNITY</h4>
									<h2>
										{communityData?.community_title}
										{/* <br /> */}
										{/* <span className="small">COMMUNITY</span> */}
									</h2>
								</div>
								<p
									dangerouslySetInnerHTML={{
										__html: communityData?.community_description,
									}}
								></p>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="left-box">
								<div className="glowing glowing-one">
									<span></span>
								</div>
								<div className="glowing glowing-two">
									<span></span>
								</div>
								<div className="glowing glowing-three">
									<span></span>
								</div>
								<Swiper
									className="nft-slider swiper mySwiper"
									effect={"cards"}
									grabCursor={true}
									modules={[EffectCards]}
								>
									<div className="swiper-wrapper">
										{NftImages?.map((data, index) => {
											return (
												<SwiperSlide className="swiper-slide" key={data?.id}>
													<figure>
														<img
															src={data?.image_path}
															alt=""
															className="img-fluid"
														/>
													</figure>
												</SwiperSlide>
											);
										})}
									</div>
								</Swiper>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <!-- About Sec End Here --> */}

			{/* <!-- Community Sec Start Here --> */}
			<section className="community_sec">
				<div className="container">
					<div className="community-box">
						<div className="row">
							{CommunityTypes?.map((data, index) => {
								return (
									<div className="col-lg-6 p-0" key={index}>
										<div
											className={
												data?.id == 1
													? "community_box general_community"
													: "community_box exclusive_community"
											}
										>
											<div className="icon-box">
												<figure>
													<img
														src={data?.image_path}
														alt=""
														className="img-fluid"
													/>
												</figure>
											</div>
											<div className="txt">
												<h3>{data?.title}</h3>
												<p
													dangerouslySetInnerHTML={{
														__html: data?.description,
													}}
												></p>
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</section>
			{/* <!-- Community Sec End Here --> */}

			{/* <!-- FAQs Sec Start Here --> */}
			<section className="faqs_sec">
				<div className="container">
					<div className="heading-wrapper">
						<div className="glowing glowing-three">
							<span></span>
						</div>
						<h5>FREQUENTLY ASKED QUESTIONS</h5>
						<h2 style={{ fontSize: "50px", lineHeight: "60px" }}>
							Exclusive Community –Diversified, Dedicated, and Secured.
						</h2>
						<p>
							Get all your burning questions answered here about our exclusive
							community.
						</p>
					</div>
					<div className="row">
						<div className="col-lg-2"></div>
						<div className="col-lg-8">
							<div className="accordion" id="accordionExample">
								{communityFaqs?.map((data, index) => {
									return (
										<div
											key={data?.id}
											className="accordion-item wow animate__animated animate__fadeInDown"
										>
											<h2
												className="accordion-header"
												id={"heading" + data?.id}
											>
												<button
													className="accordion-button"
													type="button"
													data-bs-toggle="collapse"
													data-bs-target={"#collapse" + data?.id}
													aria-expanded={data?.id == 0 ? "true" : "false"}
													aria-controls={"collapse" + data?.id}
												>
													<i className="fa fa-plus" aria-hidden="false"></i>
													<h5>{data?.questions}</h5>
												</button>
											</h2>
											<div
												id={"collapse" + data?.id}
												className={
													data?.id === 1
														? "accordion-collapse collapse show"
														: "accordion-collapse collapse"
												}
												aria-labelledby={"heading" + data?.id}
												data-bs-parent="#accordionExample"
											>
												<div className="accordion-body">
													<p
														dangerouslySetInnerHTML={{
															__html: data?.answers,
														}}
													></p>
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</div>
						<div className="col-lg-2"></div>
					</div>
				</div>
			</section>
			{/* <!-- FAQs Sec End Here --> */}

			{/* Footer Start Here */}
			<Footer />
			{/* Footer End Here */}
		</>
	);
};

export default Community;
